import axios from 'axios';
import { message } from 'antd';
import {
  PRODUCTS_API,
} from '../../../constants/API';
import {
  CREATE_PRODUCT_LOADING
} from '../types';


function createProduct(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_PRODUCT_LOADING,
        creatingProduct: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        const productResponse = await axios.post(PRODUCTS_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        console.log(productResponse)
        const { id } = productResponse.data

        dispatch({
          type: CREATE_PRODUCT_LOADING,
          creatingProduct: false
        });
        return id;
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_PRODUCT_LOADING,
          creatingProduct: false
        });
        console.log(e);
      }
  }
}
export default createProduct;
